var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    style: {
      fill: "var(--mui-palette-icon-tealHell, #0391BF)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    strokeOpacity: 0.07,
    strokeWidth: 8,
    style: {
      stroke: "var(--mui-palette-icon-teal, #036A8B)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 20H20C19.4696 20 18.9609 20.2107 18.5858 20.5858C18.2107 20.9608 18 21.4695 18 22V36C18 36.5304 18.2107 37.0391 18.5858 37.4142C18.9609 37.7893 19.4696 38 20 38H34C34.5304 38 35.0391 37.7893 35.4142 37.4142C35.7893 37.0391 36 36.5304 36 36V29M34.5 18.5C34.8978 18.1022 35.4374 17.8787 36 17.8787C36.5626 17.8787 37.1022 18.1022 37.5 18.5C37.8978 18.8978 38.1213 19.4374 38.1213 20C38.1213 20.5626 37.8978 21.1022 37.5 21.5L28 31L24 32L25 28L34.5 18.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLarge);
export default __webpack_public_path__ + "static/media/EditLarge.e46ad251b5a4d18e88138251884c0ab8.svg";
export { ForwardRef as ReactComponent };